module.exports = __webpack_public_path__ + "static/about-dca511b4f4b40e1d35663a9f00b99822.png";